import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import Swal from "sweetalert2";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";
import { useNavigate } from "react-router-dom";

const BillMaster = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [billMasterData, setBillMasterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editedRows, setEditedRows] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [billDate, setBillDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [selectedColumn, setSelectedColumn] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(billMasterData.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };

  const societyName = localStorage.getItem("society");
  const fetchBillMaster = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${BASE_URL}/bill-master/get-bill-master`,
        null,
        {
          params: {
            societyName: societyName,
          },
        }
      );

      setBillMasterData(response.data);
    } catch (error) {
      console.error("Error fetching bill master:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch bill master data",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBillMaster();
  }, []);

  useEffect(() => {
    if (selectedRows.length === 0) return;


    setBillMasterData((prev) =>
      prev.map((row) =>
        selectedRows.includes(row.bill_no)
          ? {
            ...row,
            bill_date: formatDate(billDate) || row.bill_date,
            due_date: formatDate(dueDate) || row.due_date,
          }
          : row
      )
    );
  }, [billDate, dueDate]);

  // const applyDateToSelected = () => {
  //   setBillMasterData((prev) =>
  //     prev.map((row) =>
  //       selectedRows.includes(row.bill_no)
  //         ? {
  //           ...row,
  //           bill_date: billDate || row.bill_date,
  //           due_date: dueDate || row.due_date,
  //         }
  //         : row
  //     )
  //   );
  // };

  const applyDateToSelected = () => {
  setBillMasterData((prev) =>
    prev.map((row) => {
      if (!selectedRows.includes(row.id)) return row;

      const updatedRow = {
        ...row,
        bill_date: formatDate(billDate) || row.bill_date,
        due_date: formatDate(dueDate) || row.due_date,
      };

      setEditedRows((prevEdited) => ({
        ...prevEdited,
        [row.id]: updatedRow,
      }));

      return updatedRow;
    })
  );
};
 
  const columns = billMasterData.length > 0
    ? [
      ...new Set(
        billMasterData.flatMap((item) =>
          Object.keys(item)
        )
      ),
    ]
    : [];



 const handleInputChange = (rowIndex, column, value) => {
  setBillMasterData((prev) => {
    const updated = [...prev];

    updated[rowIndex] = {
      ...updated[rowIndex],
      [column]: value,
    };

    setEditedRows((prevEdited) => ({
      ...prevEdited,
      [updated[rowIndex].id]: updated[rowIndex],
    }));

    return updated;
  });
};


const saveSelected = async () => {
  try {
    if (selectedRows.length === 0) {
      Swal.fire("Warning", "Please select at least one bill", "warning");
      return;
    }

    const selectedBills = selectedRows.map((id) => {
      const row = editedRows[id] || billMasterData.find((r) => r.id === id);

      return {
        ...row,
        bill_date: formatDate(row.bill_date),
        due_date: formatDate(row.due_date),
      };
    });

    const payload = {
      bills: selectedBills,
      billNos: selectedRows,
    };

    await axios.put(
      `${BASE_URL}/bill-master/edit-bill-by-admin`,
      payload,
      {
        params: { societyName },
      }
    );

    Swal.fire("Success", "Updated successfully", "success");
    setSelectedRows([]);
    fetchBillMaster();
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Update failed", "error");
  }
};

const handleSave = async (row) => {
  try {
    const payload = {
      bills: [
        {
          ...row,
          bill_date: formatDate(row.bill_date),
          due_date: formatDate(row.due_date),
        },
      ],
    };

    await axios.put(
      `${BASE_URL}/bill-master/edit-bill-by-admin`,
      payload,
      {
        params: { societyName },
      }
    );

    Swal.fire("Success", "Updated Successfully", "success");
    fetchBillMaster();
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Failed to update", "error");
  }
};

const formatDate = (date) => {
  if (!date) return null;
  const parts = date.split("-");
  if (parts.length !== 3) return null;
  const [year, month, day] = parts;
  return `${day}-${month}-${year}`;
};


  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          <div className="p-4">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div className="overflow-auto max-h-[500px] max-w-full border">
                <div className="mb-3 flex gap-2">

                  <button
                    onClick={saveSelected}
                    disabled={
                      selectedRows.length === 0
                    }
                    className="bg-green-600 text-white px-4 py-2 rounded"
                  >
                    Save Selected (
                    {selectedRows.length}
                    )
                  </button>

                </div>
                <div className="mb-3 flex gap-4 items-center">
                  <div>
                    <label>Bill Date</label>
                    <input
                      type="date"
                      value={billDate}
                      onChange={(e) => {
                        setBillDate(e.target.value);
                      }}
                      className="border p-2 rounded"
                    />
                  </div>

                  <div>
                    <label>Due Date</label>
                    <input
                      type="date"
                      value={dueDate}
                      onChange={(e) => {
                        setDueDate(e.target.value);
                      }}
                      className="border p-2 rounded"
                    />
                  </div>

                  <button
                    onClick={applyDateToSelected}
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    Apply To Selected
                  </button>
                </div>
                {billMasterData.length > 0 ? (

                  <table className="min-w-max border border-gray-300">
                    <thead className="sticky top-0 bg-gray-200 z-10">
                      <tr>
                        <th className="border p-2 text-center"> All
                          <input
                            type="checkbox"
                            checked={
                              billMasterData.length > 0 &&
                              selectedRows.length === billMasterData.length
                            }
                            onChange={handleSelectAll}
                          />
                        </th>

                        {columns.map((col) => {

                          if (
                            col === "is_previous_year" ||
                            col === "total_amount"
                          ) {
                            return null;
                          }

                          return (
                            <th
                              key={col}
                              className="border p-2 text-left"
                            >
                              {/* {col} */}
                              {col
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                            </th>
                          );
                        })}

                        <th className="border p-2 text-left">
                          Action
                        </th>

                      </tr>
                    </thead>

                    <tbody>
                      {billMasterData.map((row, rowIndex) => (
                        <tr
                          key={rowIndex}
                          className="hover:bg-gray-50"
                        >
                          <td className="border p-2 text-center">
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(row.id)}
                              onChange={() => {
                                setSelectedRows((prev) =>
                                  prev.includes(row.id)
                                    ? prev.filter((id) => id !== row.id)
                                    : [...prev, row.id]
                                );
                              }}
                            />
                          </td>
                          {columns.map((col, colIndex) => {
                            if (
                              col === "is_previous_year" ||
                              col === "total_amount"
                            ) {
                              return null;
                            }

                            return (
                              <td
                                key={colIndex}
                                className="border p-2"
                              >
                                <input
                                  type="text"
                                  value={row[col] ?? ""}
                                  disabled={[
                                    "id",
                                    "member_name",
                                    "unit_no",
                                    "area_sqr_ft",
                                  ].includes(col)}
                                  onChange={(e) =>
                                    handleInputChange(
                                      rowIndex,
                                      col,
                                      e.target.value
                                    )
                                  }
                                  className="w-full p-1 border rounded"
                                />
                              </td>
                            );
                          })}

                          <td className="border p-2">
                            <button
                            
                              onClick={() => handleSave(billMasterData[rowIndex])}
                              className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                            >
                              Save
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data Found</p>
                )}
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default BillMaster;